module.exports = __webpack_public_path__ + "img/error-403.09a9af6f.svg";